export const mergeMaps = <K, V>(maps: Map<K, V>[]): Map<K, V> =>
  maps.reduce((acc, map) => new Map([...acc, ...map]), new Map());
